/* eslint-disable import/prefer-default-export */
import classNames from 'classnames'
import { TextLink } from '../../components/TextLink'
import type { ImageProps, LinkItemData, LinkProps } from './types'
export function DefaultLink(props: LinkProps) {
  return <TextLink {...props} />
}

export function DefaultImage(props: ImageProps) {
  // eslint-disable-next-line jsx-a11y/alt-text
  return <img {...props} />
}
export type LinkItemProps = LinkItemData & {
  Link: React.FC<LinkProps>
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
  title?: string
  doNotOpenInNewTab?: boolean
}
export function LinkItem({
  Link,
  href,
  hidden,
  children,
  external,
  className,
  onClick,
  title,
  doNotOpenInNewTab,
}: LinkItemProps) {
  return (
    <Link
      href={href}
      onClick={onClick}
      title={title}
      aria-label={title}
      className={classNames(className, { ['hide-link']: hidden })}
      rel={external ? 'noopener noreferrer' : undefined}
      target={doNotOpenInNewTab || !external ? undefined : '_blank'}
    >
      {children}
    </Link>
  )
}
